import { cn } from "@/lib/utils";

// Pre-shuffled so consecutive indices produce visually distinct colors
const AVATAR_COLORS = [
  "#007DD8",
  "#CA00D4",
  "#0A8C00",
  "#CC6300",
  "#383B3D",
  "#39A0FF",
  "#5F0064",
  "#FE7D00",
  "#003764",
  "#11B300",
  "#95009C",
  "#642D00",
  "#191B1C",
  "#005A9E",
  "#056400",
  "#F538FF",
  "#994800",
  "#7B8285",
  "#00172F",
  "#023B00",
  "#2E0031",
  "#341400",
  "#595F61",
];

const SIZE_CLASSES = {
  sm: "size-7 text-xs",
  md: "size-9 text-sm",
  lg: "size-11 text-base",
} as const;

export interface UserAvatarProps {
  firstName: string;
  lastNameInitial?: string;
  colorIndex?: number;
  /** CSS color; when set, replaces the palette color from `colorIndex`. */
  backgroundColor?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const UserAvatar = ({
  firstName,
  lastNameInitial,
  colorIndex = 0,
  backgroundColor,
  size = "md",
  className,
}: UserAvatarProps) => {
  const resolvedBackground =
    backgroundColor ??
    AVATAR_COLORS[Math.abs(colorIndex) % AVATAR_COLORS.length];
  const usesPaletteFill = backgroundColor == null;

  const initials = (
    (firstName?.[0] ?? "") + (lastNameInitial ?? "")
  ).toUpperCase();

  return (
    <div className={cn("relative inline-flex shrink-0", className)}>
      <div
        className={cn(
          "rounded-full flex items-center justify-center font-semibold",
          usesPaletteFill ? "text-white" : "text-primary",
          SIZE_CLASSES[size]
        )}
        style={{ backgroundColor: resolvedBackground }}
      >
        {initials}
      </div>
    </div>
  );
};
